import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';

// Import from generated schemas
const { CreateAuditLogDto, AuditLogFirestoreResponse } = schemas;

// Re-export schemas for external use
export const CreateAuditLogSchema = CreateAuditLogDto;
export const AuditLogResponseSchema = AuditLogFirestoreResponse;

// Create response (backend only returns id)
export const CreateAuditLogResponseSchema = z.object({
  id: z.string(),
}).passthrough();

// Type exports
export type AuditLogResponse = z.infer<typeof AuditLogResponseSchema>;
export type CreateAuditLogResponse = z.infer<typeof CreateAuditLogResponseSchema>;
export type CreateAuditLog = z.infer<typeof CreateAuditLogSchema>;

// API factory function
export function createAuditLogApi(client: TypedApiClient) {
  return {
    getAuditLogs: (params?: {
      tableName?: string;
      recordId?: string;
      operation?: string;
      limit?: number;
      offset?: number;
    }): Promise<AuditLogResponse[]> => {
      return client.get('/audit-log', {
        params: params as Record<string, unknown>,
        responseSchema: z.array(AuditLogResponseSchema),
      });
    },

    createAuditLog: (data: CreateAuditLog): Promise<CreateAuditLogResponse> => {
      return client.post('/audit-log', {
        data,
        requestSchema: CreateAuditLogSchema,
        responseSchema: CreateAuditLogResponseSchema,
      });
    },
  };
}
